import React, { Component, Fragment } from 'react';
import SubHeader from "./../../Common/Layout/SubHeader";
import CustomFields from "./../CustomFields/CustomFields";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class CustomFieldPage extends Component {
    constructor() {
        super();
        this.state = {
            subHeaderItems: [
                // {
                //     name: "Manage Custom Fields",
                //     url:""
                // }
            ],
            helpMenuItems: [
                //{
                //    name: "Help",
                //    url: "Help URL",
                //    position: "bottom left"
                //},
                //{
                //    name: "Video",
                //    url: "Video URL",
                //    position: "bottom center"
                //},
                //{
                //    name: "User Guide",
                //    url: "",
                //    position: "bottom right"
                //},
            ]
        }
    }

    render() {
        return (
            <Fragment>
                <SubHeader subHeaderMenuItems={this.state.subHeaderItems} helpMenuItems={this.state.helpMenuItems} showClose={true} />
                <CustomFields />
            </Fragment>

        );
    }
}
export default CustomFieldPage;